import React, {PureComponent} from 'react';
import {UserContext} from "../../core/UserContext";
import {UrlBuilder} from "../../core/url/UrlBuilder";
import withStyles from '@mui/styles/withStyles';
import {PageDataContext} from "../../core/PageDataContext";
import {Link as RouterLink} from "react-router-dom";
import WorkoutsModule from "./modules/WorkoutsModule";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import './stylez.css';
import WIPIcon from "../../res/img/icon.png";
import GooglePlayButton from "../../res/img/google_play.png";
import Button from "@mui/material/Button";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import Link from "@mui/material/Link";
import Container from "@mui/material/Container";
import {Utils} from "../../core/util/Utils";
import HomeFabButton from "./modules/HomeFabButton";
import Alert from '@mui/material/Alert';
import {withRouter} from "../../hooks/withRouter";
import AppleIcon from '@mui/icons-material/Apple';
import GoogleIcon from '@mui/icons-material/Google';
import PersonIcon from '@mui/icons-material/Person';
import moment from "moment";
import CircularProgress from "@mui/material/CircularProgress";
import {Collapse} from "@mui/material";
import {AlertTitle} from "@mui/lab";
import {UserLocalStorage} from "../../core/storage/UserLocalStorage";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FadeInSection from "./FadeInSection";
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import TimerIcon from '@mui/icons-material/Timer';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import BlockIcon from '@mui/icons-material/Block';
import TrackChangesIcon from '@mui/icons-material/TrackChanges';
import ListAltIcon from '@mui/icons-material/ListAlt';
import BarChartIcon from '@mui/icons-material/BarChart';
import Chip from '@mui/material/Chip';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';

const useStyles = theme => ({
    root: {
        flexGrow: 1,
    },
    dialogRoot: {
        marginBottom: theme.spacing(2),
        cursor: 'pointer',
        paddingBottom: 0,
    },
    button: {
        marginTop: theme.spacing(2),
        marginRight: theme.spacing(2),
        marginBottom: theme.spacing(1),
        float: 'right'
    },
});

const THEME_SWATCHES = [
    { id: 'Ocean', colors: ['#1a535e', '#ff6b6b'] },
    { id: 'Sunset', colors: ['#e8651a', '#7b2d8e'] },
    { id: 'Neon Gym', colors: ['#121212', '#39ff14'] },
    { id: 'Lava', colors: ['#8b0000', '#ff4500'] },
    { id: 'Dracula', colors: ['#282a36', '#bd93f9'] },
    { id: 'Sakura', colors: ['#5c2a3e', '#e8879b'] },
    { id: 'Nord', colors: ['#2e3440', '#88c0d0'] },
    { id: 'Rose Gold', colors: ['#8e4a5e', '#d4a07a'] },
];

function Copyright() {
    return (
        <Typography variant="body2" color="textSecondary" align="center">
            {'Copyright © '}
            {'My Work in Progress '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}

class Home extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            isSigningUpAsGuest: false,
            isDonateDialogOpen: false,
        };
    }

    componentDidMount() {
        this.context.setPageData({
            title: null,
        });
    }

    redirectToGoogleAuth = () => {
        window.location = '/api/users/google-signin';
    }

    redirectToAppleAuth = () => {
        window.location = '/api/users/apple-signin';
    }

    signUpAsGuest = async (event, setUser) => {
        event.preventDefault();

        this.setState({
            isSigningUpAsGuest: true
        });

        let guestUser = {
            dateCreated: moment().format('L, h:mm:ss A'),
        };

        let response = await fetch(UrlBuilder.user.SignUpAsGuestApi(), {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(guestUser)
        });

        let jsonResponse = await response.json();

        if (response.status === 200) {
            setUser(jsonResponse['data']);
            this.props.navigate('/');
        }

        this.setState({
            isSigningUpAsGuest: false,
        })
    }

    // ── Shared auth buttons ──

    renderAuthButtons = (variant) => {
        const isHero = variant === 'hero';
        const buttonWidth = isHero ? 280 : 250;
        const buttonHeight = 44;

        return (
            <UserContext.Consumer>
                {({user, setUser}) => (
                    <Box display="flex" flexDirection="column" alignItems={isHero ? 'flex-start' : 'center'}>
                        <Grid container direction={isHero ? 'column' : 'row'} justifyContent="center" alignItems="center" spacing={1}>
                            <Grid item>
                                <Button
                                    sx={{ width: buttonWidth, height: buttonHeight }}
                                    variant="contained"
                                    onClick={this.redirectToGoogleAuth}
                                    size="medium"
                                    startIcon={<GoogleIcon />}
                                >
                                    Continue with Google
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button
                                    sx={{ width: buttonWidth, height: buttonHeight }}
                                    variant="contained"
                                    onClick={this.redirectToAppleAuth}
                                    size="medium"
                                    startIcon={<AppleIcon />}
                                >
                                    Continue with Apple
                                </Button>
                            </Grid>
                        </Grid>

                        <Box display="flex" justifyContent={isHero ? 'flex-start' : 'center'} alignItems="center"
                             sx={{ mt: 1.5, mb: 0.5, width: '100%', pl: isHero ? 0.5 : 0 }}>
                            <Typography variant="overline" color="text.secondary">
                                Or Manually
                            </Typography>
                        </Box>

                        <Grid container direction="row" justifyContent={isHero ? 'flex-start' : 'center'} spacing={1}>
                            <Grid item>
                                <Link component={RouterLink} to={UrlBuilder.user.SignInPage()}>
                                    <Button startIcon={<LockOpenIcon />} variant="outlined" size="medium" color="primary">
                                        Sign in
                                    </Button>
                                </Link>
                            </Grid>
                            <Grid item>
                                <Link component={RouterLink} to={UrlBuilder.user.SignUpPage()}>
                                    <Button startIcon={<PersonAddIcon />} variant="outlined" size="medium" color="secondary">
                                        Sign Up
                                    </Button>
                                </Link>
                            </Grid>
                        </Grid>

                        <Box sx={{ mt: 1.5, pl: isHero ? 0.5 : 0, textAlign: isHero ? 'left' : 'center', width: '100%' }}>
                            <Button
                                type="submit"
                                startIcon={this.state.isSigningUpAsGuest ? <CircularProgress size="1rem" color="inherit" /> : <PersonIcon />}
                                variant="text"
                                size="small"
                                color="primary"
                                sx={{ fontSize: 13, textTransform: 'none' }}
                                onClick={e => this.signUpAsGuest(e, setUser)}
                                disabled={this.state.isSigningUpAsGuest}
                            >
                                Try as Guest
                            </Button>
                        </Box>
                    </Box>
                )}
            </UserContext.Consumer>
        );
    }

    // ── Section renderers ──

    renderHero = () => {
        return (
            <Box sx={{
                pt: { xs: 5, md: 10 },
                pb: { xs: 5, md: 8 },
                mx: { xs: -2, md: -3 },
                px: { xs: 2, md: 3 },
                background: (theme) => theme.palette.mode === 'dark'
                    ? 'radial-gradient(ellipse at 50% 0%, rgba(245,0,87,0.08) 0%, transparent 60%)'
                    : 'radial-gradient(ellipse at 50% 0%, rgba(245,0,87,0.05) 0%, transparent 60%)',
                textAlign: 'center',
            }}>
                <Box sx={{ maxWidth: 680, mx: 'auto', mb: { xs: 4, md: 5 } }}>
                    <Box sx={{ mb: 3 }}>
                        <img src={WIPIcon} width={88} alt="WIP" style={{ borderRadius: 20 }} />
                    </Box>

                    <Typography variant="h1" sx={{
                        fontWeight: 800,
                        fontSize: { xs: 36, sm: 44, md: 56 },
                        lineHeight: 1.1,
                        mb: 2.5,
                        color: 'text.primary',
                        letterSpacing: '-0.02em',
                    }}>
                        Built for lifters who{' '}
                        <Box component="span" sx={{
                            color: 'secondary.main',
                        }}>
                            take it seriously.
                        </Box>
                    </Typography>

                    <Typography variant="body1" sx={{
                        fontSize: { xs: 16, md: 19 },
                        color: 'text.secondary',
                        mb: 4,
                        lineHeight: 1.7,
                        maxWidth: 560,
                        mx: 'auto',
                    }}>
                        A workout tracker with RPE and RIR tracking, auto-detected PRs, custom exercises with muscle breakdowns,
                        and AI that actually knows your training history. Free forever, no ads.
                    </Typography>

                    {this.renderAuthButtons('compact')}
                </Box>

                <Box sx={{ display: 'flex', justifyContent: 'center', mt: { xs: 3, md: 4 } }}>
                    <div className="phone-mockup">
                        <video autoPlay loop muted playsInline width="100%" src="/promo.mp4" />
                    </div>
                </Box>
            </Box>
        );
    }

    renderStatsBar = () => {
        const stats = [
            { number: '100%', label: 'Customizable', icon: <FitnessCenterIcon /> },
            { number: '71', label: 'Badges to Earn', icon: <EmojiEventsIcon /> },
            { number: '8', label: 'Goal Types', icon: <TrackChangesIcon /> },
            { number: '0', label: 'Ads. Ever.', icon: <BlockIcon /> },
        ];

        return (
            <FadeInSection>
                <Box sx={{
                    py: { xs: 4, md: 5 },
                    mx: { xs: -2, md: -3 },
                    px: { xs: 2, md: 3 },
                }}>
                    <Grid container spacing={2} justifyContent="center">
                        {stats.map((stat, i) => (
                            <Grid item xs={6} md={3} key={i}>
                                <Box sx={{
                                    textAlign: 'center',
                                    py: 3,
                                    px: 2,
                                    borderRadius: 3,
                                    border: '1px solid',
                                    borderColor: 'divider',
                                    bgcolor: 'background.paper',
                                    transition: 'border-color 0.25s',
                                    '&:hover': { borderColor: 'secondary.main' },
                                }}>
                                    <Box sx={{
                                        width: 40,
                                        height: 40,
                                        borderRadius: '12px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        mx: 'auto',
                                        mb: 1.5,
                                        bgcolor: (theme) => theme.palette.mode === 'dark'
                                            ? 'rgba(245,0,87,0.12)'
                                            : 'rgba(245,0,87,0.06)',
                                    }}>
                                        {React.cloneElement(stat.icon, { sx: { fontSize: 22, color: 'secondary.main' } })}
                                    </Box>
                                    <Typography variant="h3" sx={{
                                        fontWeight: 800,
                                        fontSize: { xs: 30, md: 36 },
                                        color: 'text.primary',
                                        letterSpacing: '-0.02em',
                                    }}>
                                        {stat.number}
                                    </Typography>
                                    <Typography variant="body2" sx={{ color: 'text.secondary', fontWeight: 500, fontSize: 13 }}>
                                        {stat.label}
                                    </Typography>
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            </FadeInSection>
        );
    }

    renderFeatureShowcase = () => {
        const features = [
            {
                icon: <FitnessCenterIcon />,
                title: 'Fully Customizable',
                desc: 'Create exercises with percentage-based muscle breakdowns across 11 muscle groups. Five tracking types: weight+reps, weight+time, reps, distance+time, and time.',
                visual: (
                    <Box sx={{
                        borderRadius: 1,
                        border: '1px solid',
                        borderColor: 'divider',
                        overflow: 'hidden',
                    }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, px: 1.5, py: 1, bgcolor: 'background.default' }}>
                            <Box sx={{
                                width: 28, height: 28, borderRadius: '50%',
                                bgcolor: '#e91e63', color: '#fff',
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                fontSize: 13, fontWeight: 600,
                            }}>I</Box>
                            <Box>
                                <Typography sx={{ fontSize: 12, fontWeight: 600 }}>Incline Dumbbell Press</Typography>
                                <Typography sx={{ fontSize: 10, color: 'text.secondary' }}>Chest &middot; Weight & Reps</Typography>
                            </Box>
                        </Box>
                        <Divider />
                        <Box sx={{ px: 1.5, py: 1 }}>
                            <Typography variant="overline" sx={{ fontSize: 9, color: 'text.secondary', letterSpacing: 1 }}>MUSCLES</Typography>
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mt: 0.3 }}>
                                {[{ m: 'Chest', p: '60%' }, { m: 'Shoulders', p: '25%' }, { m: 'Triceps', p: '15%' }].map(item => (
                                    <Typography key={item.m} sx={{ fontSize: 10, color: 'text.secondary' }}>
                                        {item.m} {item.p}
                                    </Typography>
                                ))}
                            </Box>
                        </Box>
                    </Box>
                ),
            },
            {
                icon: <ListAltIcon />,
                title: 'Smart Routines',
                desc: 'Drag-and-drop exercise ordering, supersets, color coding, and archiving. Structure your training blocks exactly how you program them.',
                visual: (
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.8 }}>
                        {[
                            { name: 'Bench Press', letter: 'B', color: '#2196f3', sub: '4 sets · 2 days ago' },
                            { name: 'Incline DB Press', letter: 'I', color: '#e91e63', sub: '3 sets · 2 days ago' },
                            { name: 'Cable Flyes', letter: 'C', color: '#4caf50', sub: '3 sets · 5 days ago' },
                        ].map((ex, i) => (
                            <Box key={i} sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                                px: 1.5,
                                py: 0.8,
                                borderRadius: 1,
                                border: '1px solid',
                                borderColor: 'divider',
                            }}>
                                <DragIndicatorIcon sx={{ fontSize: 16, color: 'text.secondary', opacity: 0.35 }} />
                                <Box sx={{
                                    width: 26, height: 26, borderRadius: '50%',
                                    bgcolor: ex.color, color: '#fff',
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    fontSize: 12, fontWeight: 600, flexShrink: 0,
                                }}>{ex.letter}</Box>
                                <Box sx={{ minWidth: 0 }}>
                                    <Typography sx={{ fontSize: 11, fontWeight: 600 }}>{ex.name}</Typography>
                                    <Typography sx={{ fontSize: 9, color: 'text.secondary' }}>{ex.sub}</Typography>
                                </Box>
                            </Box>
                        ))}
                    </Box>
                ),
            },
            {
                icon: <TimerIcon />,
                title: 'Track Live Workouts',
                desc: 'Log RPE and RIR per set, compare against previous sessions in real-time, and track rest periods with audio and haptic alerts.',
                visual: (
                    <Box sx={{
                        borderRadius: 1,
                        border: '1px solid',
                        borderColor: 'divider',
                        overflow: 'hidden',
                    }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, px: 1.5, py: 0.8, bgcolor: 'background.default' }}>
                            <Box sx={{
                                width: 26, height: 26, borderRadius: '50%',
                                bgcolor: '#2196f3', color: '#fff',
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                fontSize: 12, fontWeight: 600,
                            }}>B</Box>
                            <Typography sx={{ fontSize: 12, fontWeight: 600, flexGrow: 1 }}>Bench Press</Typography>
                            <Chip label="1:30" size="small" icon={<TimerIcon sx={{ fontSize: '14px !important' }} />}
                                color="error" sx={{ height: 22, fontSize: 11, fontWeight: 700 }} />
                        </Box>
                        <Box sx={{ px: 1.5 }}>
                            <Box sx={{
                                display: 'flex', gap: 1, py: 0.5,
                                borderBottom: '1px solid', borderColor: 'divider',
                            }}>
                                {['SET', 'KG', 'REPS', 'RPE'].map(h => (
                                    <Typography key={h} variant="overline" sx={{ fontSize: 9, color: 'text.secondary', flex: 1, letterSpacing: 0.5 }}>
                                        {h}
                                    </Typography>
                                ))}
                            </Box>
                            {[
                                { set: 1, kg: '80', reps: '8', rpe: '7' },
                                { set: 2, kg: '85', reps: '6', rpe: '8' },
                                { set: 3, kg: '85', reps: '6', rpe: '9' },
                            ].map((row) => (
                                <Box key={row.set} sx={{
                                    display: 'flex', gap: 1, py: 0.5,
                                    borderBottom: '1px solid', borderColor: 'divider',
                                }}>
                                    <Box sx={{ flex: 1, display: 'flex', alignItems: 'center' }}>
                                        <Box sx={{
                                            bgcolor: 'action.selected', borderRadius: 1,
                                            px: 0.5, py: 0.125, minWidth: 16, textAlign: 'center',
                                        }}>
                                            <Typography sx={{ fontSize: 10 }}>{row.set}</Typography>
                                        </Box>
                                    </Box>
                                    <Typography sx={{ fontSize: 12, flex: 1 }}>{row.kg}</Typography>
                                    <Typography sx={{ fontSize: 12, flex: 1 }}>{row.reps}</Typography>
                                    <Typography sx={{ fontSize: 12, flex: 1, color: 'text.secondary' }}>@{row.rpe}</Typography>
                                </Box>
                            ))}
                        </Box>
                    </Box>
                ),
            },
            {
                icon: <EmojiEventsIcon />,
                title: 'Personal Records & Streaks',
                desc: 'PRs are auto-detected across every lift. Weekly streak tracking keeps you accountable. 71 achievement milestones to hit.',
                visual: (
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        <Box sx={{
                            borderRadius: '12px',
                            px: 1.5, py: 1,
                            background: 'linear-gradient(135deg, #FFD700 0%, #FFA000 50%, #FF8F00 100%)',
                            boxShadow: '0 2px 8px rgba(255, 165, 0, 0.3)',
                            textAlign: 'center',
                        }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5, mb: 0.3 }}>
                                <EmojiEventsIcon sx={{ fontSize: 14, color: '#3E2723' }} />
                                <Typography sx={{ fontSize: 11, fontWeight: 800, color: '#3E2723', letterSpacing: '0.05em' }}>
                                    NEW PR!
                                </Typography>
                                <EmojiEventsIcon sx={{ fontSize: 14, color: '#3E2723' }} />
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.8 }}>
                                <Typography sx={{ fontSize: 10, color: '#3E2723', textDecoration: 'line-through', opacity: 0.6 }}>85 kg</Typography>
                                <Typography sx={{ fontSize: 10, color: '#2E7D32', fontWeight: 700 }}>&rarr;</Typography>
                                <Typography sx={{ fontSize: 11, color: '#1B5E20', fontWeight: 700 }}>90 kg</Typography>
                            </Box>
                        </Box>
                        <Box sx={{
                            borderRadius: 1,
                            border: '1px solid',
                            borderColor: 'divider',
                            px: 1.5, py: 1,
                        }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8, mb: 0.8 }}>
                                <LocalFireDepartmentIcon sx={{ fontSize: 18, color: '#ff6d00' }} />
                                <Typography sx={{ fontSize: 12, fontWeight: 600 }}>5 week streak</Typography>
                            </Box>
                            <Box sx={{ width: '100%', bgcolor: 'action.hover', borderRadius: 2, height: 6, overflow: 'hidden' }}>
                                <Box sx={{ width: '57%', height: '100%', bgcolor: 'primary.main', borderRadius: 2 }} />
                            </Box>
                            <Typography sx={{ fontSize: 9, color: 'text.secondary', mt: 0.4 }}>4 / 7 this week</Typography>
                        </Box>
                    </Box>
                ),
            },
            {
                icon: <BarChartIcon />,
                title: 'Stats That Matter',
                desc: 'Volume trends, workout frequency, duration tracking, and body measurements with line graphs. Spot plateaus and track periodization.',
                visual: (
                    <Box sx={{
                        borderRadius: 1,
                        border: '1px solid',
                        borderColor: 'divider',
                        overflow: 'hidden',
                    }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, px: 1.5, py: 0.8, bgcolor: 'background.default' }}>
                            <BarChartIcon sx={{ fontSize: 18, color: 'text.secondary' }} />
                            <Typography sx={{ fontSize: 12, fontWeight: 600 }}>Weekly Volume</Typography>
                        </Box>
                        <Divider />
                        <Box sx={{ px: 1.5, pt: 1, pb: 0.5 }}>
                            <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.8, mb: 0.3 }}>
                                <Typography sx={{ fontWeight: 700, fontSize: 20 }}>
                                    12,450
                                </Typography>
                                <Typography sx={{ fontSize: 12, color: 'text.secondary' }}>kg</Typography>
                                <Typography sx={{ fontSize: 11, color: 'success.main', fontWeight: 600, ml: 'auto' }}>
                                    +8%
                                </Typography>
                            </Box>
                        </Box>
                        <Box sx={{ px: 0.5, pb: 0.5 }}>
                            <svg viewBox="0 0 200 45" style={{ width: '100%', height: 45, display: 'block' }}>
                                <defs>
                                    <linearGradient id="graphGrad" x1="0" y1="0" x2="0" y2="1">
                                        <stop offset="0%" stopColor="#f50057" stopOpacity="0.25" />
                                        <stop offset="100%" stopColor="#f50057" stopOpacity="0.02" />
                                    </linearGradient>
                                </defs>
                                <path
                                    d="M5,38 L33,35 L62,33 L90,28 L118,24 L147,19 L175,14 L195,7"
                                    fill="none" stroke="#f50057" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
                                />
                                <path
                                    d="M5,38 L33,35 L62,33 L90,28 L118,24 L147,19 L175,14 L195,7 L195,45 L5,45 Z"
                                    fill="url(#graphGrad)"
                                />
                                <circle cx="195" cy="7" r="2.5" fill="#f50057" />
                            </svg>
                        </Box>
                    </Box>
                ),
            },
            {
                icon: <AutoAwesomeIcon />,
                title: 'AI Training Assistant',
                desc: 'An AI with access to your full training data. Analyze weak points, generate programs, and get weekly breakdowns — not generic advice.',
                visual: (
                    <Box sx={{
                        borderRadius: 1,
                        border: '1px solid',
                        borderColor: 'divider',
                        overflow: 'hidden',
                    }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, px: 1.5, py: 0.8, bgcolor: 'background.default' }}>
                            <AutoAwesomeIcon sx={{ fontSize: 16, color: 'secondary.main' }} />
                            <Typography sx={{ fontSize: 12, fontWeight: 600 }}>AI Assistant</Typography>
                        </Box>
                        <Divider />
                        <Box sx={{ p: 1.2, display: 'flex', flexDirection: 'column', gap: 0.8 }}>
                            <Box sx={{
                                alignSelf: 'flex-end',
                                bgcolor: 'primary.main',
                                color: 'primary.contrastText',
                                px: 1.2, py: 0.5,
                                borderRadius: 1.5,
                                maxWidth: '85%',
                            }}>
                                <Typography sx={{ fontSize: 10 }}>What should I train today?</Typography>
                            </Box>
                            <Box sx={{ alignSelf: 'flex-start', maxWidth: '90%' }}>
                                <Typography sx={{ fontSize: 10, color: 'text.secondary', lineHeight: 1.5 }}>
                                    Based on your history, you haven't hit legs in 5 days. I'd suggest your <strong>Leg Day A</strong> routine.
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                ),
            },
        ];

        return (
            <FadeInSection>
                <Box sx={{ py: { xs: 6, md: 10 } }}>
                    <Box sx={{ textAlign: 'center', mb: { xs: 4, md: 6 } }}>
                        <Typography variant="h4" sx={{ fontWeight: 700, mb: 1, fontSize: { xs: 26, md: 34 } }}>
                            The tools serious lifters actually need.
                        </Typography>
                        <Typography variant="body1" sx={{ color: 'text.secondary' }}>
                            No paywalls on core features. No ads. No data selling.
                        </Typography>
                    </Box>

                    <Grid container spacing={3}>
                        {features.map((feat, i) => (
                            <Grid item xs={12} sm={6} md={4} key={i}>
                                <Box sx={{
                                    p: 3,
                                    height: '100%',
                                    borderRadius: 3,
                                    border: '1px solid',
                                    borderColor: 'divider',
                                    bgcolor: 'background.paper',
                                    transition: 'transform 0.25s, box-shadow 0.25s, border-color 0.25s',
                                    '&:hover': {
                                        transform: 'translateY(-4px)',
                                        boxShadow: 8,
                                        borderColor: 'secondary.main',
                                    },
                                }}>
                                    {feat.visual ? (
                                        <Box sx={{ mb: 2 }}>{feat.visual}</Box>
                                    ) : (
                                        <Box sx={{
                                            width: 48,
                                            height: 48,
                                            borderRadius: '14px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            background: (theme) => `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
                                            mb: 2,
                                        }}>
                                            {React.cloneElement(feat.icon, { sx: { fontSize: 24, color: '#fff' } })}
                                        </Box>
                                    )}
                                    <Typography variant="h6" sx={{ fontWeight: 600, mb: 0.8, fontSize: 17 }}>
                                        {feat.title}
                                    </Typography>
                                    <Typography variant="body2" sx={{ color: 'text.secondary', lineHeight: 1.6, fontSize: 13.5 }}>
                                        {feat.desc}
                                    </Typography>
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            </FadeInSection>
        );
    }

    renderHowItWorks = () => {
        const steps = [
            {
                num: '1',
                icon: <PersonAddIcon />,
                title: 'Sign up in 3 seconds',
                desc: 'Google, Apple, or try as a guest. No email verification required.',
            },
            {
                num: '2',
                icon: <PlayArrowIcon />,
                title: 'Set up your program',
                desc: 'Build your routines, define your exercises, set goals with deadlines. Structure it your way.',
            },
            {
                num: '3',
                icon: <TrendingUpIcon />,
                title: 'Train and track',
                desc: 'Log every set, hit PRs, track streaks, and let the AI analyze your progress over time.',
            },
        ];

        return (
            <FadeInSection>
                <Box sx={{
                    py: { xs: 6, md: 8 },
                    mx: { xs: -2, md: -3 },
                    px: { xs: 2, md: 3 },
                }}>
                    <Box sx={{ textAlign: 'center', mb: { xs: 4, md: 6 } }}>
                        <Typography variant="h4" sx={{ fontWeight: 700, fontSize: { xs: 26, md: 34 } }}>
                            Up and running in minutes
                        </Typography>
                    </Box>

                    <Grid container spacing={3} justifyContent="center">
                        {steps.map((step, i) => (
                            <Grid item xs={12} md={4} key={i}>
                                <Box sx={{
                                    textAlign: 'center',
                                    p: 3,
                                    borderRadius: 3,
                                    border: '1px solid',
                                    borderColor: 'divider',
                                    bgcolor: 'background.paper',
                                    height: '100%',
                                    position: 'relative',
                                }}>
                                    <Box sx={{
                                        width: 36,
                                        height: 36,
                                        borderRadius: '50%',
                                        background: (theme) => `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
                                        color: '#fff',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        mx: 'auto',
                                        mb: 2,
                                        fontWeight: 700,
                                        fontSize: 16,
                                    }}>
                                        {step.num}
                                    </Box>
                                    <Box sx={{
                                        width: 44,
                                        height: 44,
                                        borderRadius: '12px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        mx: 'auto',
                                        mb: 2,
                                        bgcolor: (theme) => theme.palette.mode === 'dark'
                                            ? 'rgba(255,255,255,0.05)'
                                            : 'rgba(0,0,0,0.03)',
                                    }}>
                                        {React.cloneElement(step.icon, { sx: { fontSize: 24, color: 'secondary.main' } })}
                                    </Box>
                                    <Typography variant="h6" sx={{ fontWeight: 600, mb: 1, fontSize: 17 }}>
                                        {step.title}
                                    </Typography>
                                    <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: 13.5, lineHeight: 1.6 }}>
                                        {step.desc}
                                    </Typography>
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            </FadeInSection>
        );
    }

    renderAiHighlight = () => {
        return (
            <FadeInSection>
                <Box sx={{
                    py: { xs: 6, md: 10 },
                    mx: { xs: -2, md: -3 },
                    px: { xs: 2, md: 3 },
                    bgcolor: 'background.paper',
                    borderTop: '1px solid',
                    borderBottom: '1px solid',
                    borderColor: 'divider',
                }}>
                    <Grid container spacing={5} alignItems="center">
                        <Grid item xs={12} md={5}>
                            <Typography variant="overline" sx={{
                                color: 'secondary.main',
                                letterSpacing: 2,
                                fontWeight: 600,
                                fontSize: 12,
                            }}>
                                POWERED BY AI
                            </Typography>
                            <Typography variant="h4" sx={{
                                fontWeight: 700,
                                mt: 1,
                                mb: 2,
                                fontSize: { xs: 26, md: 32 },
                            }}>
                                Your workout data, answered
                            </Typography>
                            <Typography variant="body1" sx={{ color: 'text.secondary', mb: 3, lineHeight: 1.7 }}>
                                Not a generic chatbot. This AI has read access to your exercises, routines, logs, PRs, goals, and measurements. Ask it real questions and get answers grounded in your actual data.
                            </Typography>

                            {[
                                '14 function-calling tools with access to your real data',
                                'Weekly training digest and per-workout analysis',
                                'Generates routines, exercises, and programs for you',
                            ].map((item, i) => (
                                <Box key={i} sx={{ display: 'flex', alignItems: 'center', mb: 1.2 }}>
                                    <CheckCircleIcon sx={{ fontSize: 20, color: 'secondary.main', mr: 1.2 }} />
                                    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                        {item}
                                    </Typography>
                                </Box>
                            ))}
                        </Grid>

                        <Grid item xs={12} md={7}>
                            <Box sx={{
                                maxWidth: 440,
                                mx: 'auto',
                                borderRadius: 1,
                                border: '1px solid',
                                borderColor: 'divider',
                                bgcolor: 'background.paper',
                                boxShadow: 8,
                                overflow: 'hidden',
                            }}>
                                <Box sx={{
                                    px: 2,
                                    py: 1.2,
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1,
                                    borderBottom: '1px solid',
                                    borderColor: 'divider',
                                    bgcolor: 'background.default',
                                }}>
                                    <AutoAwesomeIcon sx={{ fontSize: 18, color: 'text.primary' }} />
                                    <Typography variant="body2" sx={{ fontWeight: 600, fontSize: 14 }}>AI Assistant</Typography>
                                    <Typography variant="caption" sx={{ ml: 'auto', color: 'text.secondary', fontSize: 11 }}>
                                        12 credits left
                                    </Typography>
                                </Box>
                                <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                                    <Box sx={{
                                        alignSelf: 'flex-end',
                                        bgcolor: 'primary.main',
                                        color: 'primary.contrastText',
                                        px: 1.5,
                                        py: 1,
                                        borderRadius: 1.5,
                                        maxWidth: '80%',
                                    }}>
                                        <Typography sx={{ fontSize: 14 }}>
                                            How was my training this week?
                                        </Typography>
                                    </Box>

                                    <Box sx={{ alignSelf: 'flex-start', maxWidth: '95%' }}>
                                        <Typography sx={{ fontSize: 14, lineHeight: 1.6, color: 'text.primary' }}>
                                            You completed <strong>4 workouts</strong> this week hitting chest, back, and legs. Total volume: <strong>12,450 kg</strong> &mdash; up 8% from last week. Your bench press is just 2 kg away from a new PR!
                                        </Typography>
                                    </Box>

                                    <Box sx={{
                                        alignSelf: 'flex-end',
                                        bgcolor: 'primary.main',
                                        color: 'primary.contrastText',
                                        px: 1.5,
                                        py: 1,
                                        borderRadius: 1.5,
                                        maxWidth: '80%',
                                    }}>
                                        <Typography sx={{ fontSize: 14 }}>
                                            Create a push day routine for me
                                        </Typography>
                                    </Box>

                                    <Box sx={{ alignSelf: 'flex-start', maxWidth: '95%' }}>
                                        <Typography sx={{ fontSize: 14, lineHeight: 1.6, color: 'text.primary' }}>
                                            Done! I created <strong>"Push Day A"</strong> with Bench Press, OHP, Incline DB Press, Lateral Raises, and Tricep Pushdowns based on your training history.
                                        </Typography>
                                    </Box>
                                </Box>

                                <Box sx={{ px: 2, pb: 1.5, display: 'flex', gap: 0.8, flexWrap: 'wrap' }}>
                                    {['Analyze my PRs', 'Weekly digest', 'Build a program'].map(s => (
                                        <Box key={s} sx={{
                                            px: 1.5, py: 0.6,
                                            borderRadius: 1,
                                            bgcolor: 'action.hover',
                                            cursor: 'default',
                                            transition: 'background-color 0.15s',
                                        }}>
                                            <Typography sx={{ fontSize: 12, color: 'text.secondary' }}>{s}</Typography>
                                        </Box>
                                    ))}
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </FadeInSection>
        );
    }

    renderCustomizationTease = () => {
        const animationNames = [
            { name: 'Confetti', emoji: '\u{1F389}' },
            { name: 'Fire', emoji: '\u{1F525}' },
            { name: 'Lightning', emoji: '\u{26A1}' },
            { name: 'Level Up', emoji: '\u{1F3AE}' },
            { name: 'Fireworks', emoji: '\u{1F386}' },
            { name: 'Aurora', emoji: '\u{2728}' },
            { name: 'Shockwave', emoji: '\u{1F4A5}' },
        ];

        return (
            <FadeInSection>
                <Box sx={{ py: { xs: 6, md: 8 } }}>
                    <Box sx={{ textAlign: 'center', mb: { xs: 4, md: 5 } }}>
                        <Typography variant="h4" sx={{ fontWeight: 700, mb: 1, fontSize: { xs: 26, md: 34 } }}>
                            Make it yours
                        </Typography>
                        <Typography variant="body1" sx={{ color: 'text.secondary' }}>
                            20 color themes. 8 workout celebrations. 71 achievement badges.
                        </Typography>
                    </Box>

                    <Grid container spacing={3}>
                        <Grid item xs={12} md={6}>
                            <Box sx={{
                                p: 3,
                                borderRadius: 3,
                                border: '1px solid',
                                borderColor: 'divider',
                                bgcolor: 'background.paper',
                                height: '100%',
                            }}>
                                <Typography variant="overline" sx={{ color: 'text.secondary', letterSpacing: 1.5, fontSize: 11 }}>
                                    COLOR THEMES
                                </Typography>
                                <Typography variant="body2" sx={{ color: 'text.secondary', mb: 2, fontSize: 13 }}>
                                    Pick a palette that fits your vibe — from Neon Gym to Sakura.
                                </Typography>
                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5 }}>
                                    {THEME_SWATCHES.map((swatch) => (
                                        <Box key={swatch.id} sx={{
                                            textAlign: 'center',
                                            transition: 'transform 0.2s',
                                            '&:hover': { transform: 'scale(1.1)' },
                                            cursor: 'default',
                                        }}>
                                            <Box sx={{
                                                width: 48,
                                                height: 48,
                                                borderRadius: '14px',
                                                overflow: 'hidden',
                                                boxShadow: 3,
                                                display: 'flex',
                                            }}>
                                                <Box sx={{ width: '50%', height: '100%', bgcolor: swatch.colors[0] }} />
                                                <Box sx={{ width: '50%', height: '100%', bgcolor: swatch.colors[1] }} />
                                            </Box>
                                            <Typography variant="caption" sx={{ fontSize: 9, color: 'text.secondary', mt: 0.5, display: 'block' }}>
                                                {swatch.id}
                                            </Typography>
                                        </Box>
                                    ))}
                                </Box>
                            </Box>
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <Box sx={{
                                p: 3,
                                borderRadius: 3,
                                border: '1px solid',
                                borderColor: 'divider',
                                bgcolor: 'background.paper',
                                height: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                            }}>
                                <Typography variant="overline" sx={{ color: 'text.secondary', letterSpacing: 1.5, fontSize: 11 }}>
                                    WORKOUT CELEBRATIONS
                                </Typography>
                                <Typography variant="body2" sx={{ color: 'text.secondary', mb: 2, fontSize: 13 }}>
                                    Finish a workout and pick how you celebrate.
                                </Typography>
                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 3 }}>
                                    {animationNames.map((anim) => (
                                        <Chip
                                            key={anim.name}
                                            label={`${anim.emoji}  ${anim.name}`}
                                            size="small"
                                            variant="outlined"
                                            sx={{
                                                transition: 'transform 0.2s, border-color 0.2s',
                                                '&:hover': {
                                                    transform: 'translateY(-2px)',
                                                    borderColor: 'secondary.main',
                                                },
                                                fontSize: 12,
                                            }}
                                        />
                                    ))}
                                </Box>

                                <Box sx={{ mt: 'auto' }}>
                                    <Typography variant="overline" sx={{ color: 'text.secondary', letterSpacing: 1.5, fontSize: 11 }}>
                                        ACHIEVEMENT BADGES
                                    </Typography>
                                    <Box sx={{ display: 'flex', gap: 1, mt: 1, flexWrap: 'wrap' }}>
                                        {[
                                            { icon: <FitnessCenterIcon />, label: 'First Workout' },
                                            { icon: <LocalFireDepartmentIcon />, label: '4-Week Streak' },
                                            { icon: <EmojiEventsIcon />, label: '10 PRs' },
                                            { icon: <BarChartIcon />, label: '100k Volume' },
                                        ].map((badge) => (
                                            <Box key={badge.label} sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 0.5,
                                                px: 1,
                                                py: 0.5,
                                                borderRadius: '8px',
                                                bgcolor: (theme) => theme.palette.mode === 'dark'
                                                    ? 'rgba(255,215,0,0.08)'
                                                    : 'rgba(255,215,0,0.06)',
                                                border: '1px solid',
                                                borderColor: (theme) => theme.palette.mode === 'dark'
                                                    ? 'rgba(255,215,0,0.2)'
                                                    : 'rgba(255,215,0,0.25)',
                                            }}>
                                                {React.cloneElement(badge.icon, { sx: { fontSize: 14, color: '#FFD700' } })}
                                                <Typography sx={{ fontSize: 10, fontWeight: 500 }}>{badge.label}</Typography>
                                            </Box>
                                        ))}
                                    </Box>
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </FadeInSection>
        );
    }

    renderFinalCta = () => {
        return (
            <FadeInSection>
                <Box sx={{
                    py: { xs: 6, md: 8 },
                    mx: { xs: -2, md: -3 },
                    px: { xs: 2, md: 3 },
                    background: 'linear-gradient(160deg, rgba(45,59,74,0.04) 0%, rgba(245,0,87,0.04) 100%)',
                    textAlign: 'center',
                }}>
                    <Container maxWidth="sm">
                        <Typography variant="h4" sx={{ fontWeight: 700, mb: 1.5, fontSize: { xs: 26, md: 34 } }}>
                            Start tracking today. It's free.
                        </Typography>
                        <Typography variant="body1" sx={{ color: 'text.secondary', mb: 4 }}>
                            No credit card. No trial period. No catch. Just log in and train.
                        </Typography>

                        {this.renderAuthButtons('compact')}

                        <Box sx={{ mt: 3 }}>
                            <a href="https://play.google.com/store/apps/details?id=app.myworkinprogress.twa" target="_blank" rel="noopener noreferrer">
                                <img src={GooglePlayButton} alt="Get it on Google Play" style={{ height: 40 }} />
                            </a>
                        </Box>
                    </Container>
                </Box>
            </FadeInSection>
        );
    }

    renderFooter = () => {
        return (
            <Box sx={{
                py: 4,
                textAlign: 'center',
                borderTop: '1px solid',
                borderColor: 'divider',
            }}>
                <Box sx={{ display: 'flex', justifyContent: 'center', gap: 3, mb: 2 }}>
                    <Link component={RouterLink} to={UrlBuilder.user.privacyPage()}>
                        <Typography variant="body2" sx={{ color: 'text.secondary', '&:hover': { color: 'text.primary' } }}>
                            Privacy Policy
                        </Typography>
                    </Link>
                    <Link component={RouterLink} to={UrlBuilder.misc.manualPage()}>
                        <Typography variant="body2" sx={{ color: 'text.secondary', '&:hover': { color: 'text.primary' } }}>
                            Help
                        </Typography>
                    </Link>
                </Box>
                <Copyright />
                <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block', mt: 1 }}>
                    Made with care by a solo developer.
                </Typography>
            </Box>
        );
    }

    // ── No-user page ──

    renderNoUserPage = () => {
        let error = (new URLSearchParams(this.props.location.search)).get('error');

        return (
            <div>
                {error === 'auth' ? (
                    <Box sx={{ pt: 2 }}>
                        <Alert severity="warning">Something went wrong with external authentication. Please try again or manually.</Alert>
                    </Box>
                ) : null}

                {this.renderHero()}
                {this.renderStatsBar()}
                {this.renderFeatureShowcase()}
                {this.renderHowItWorks()}
                {this.renderAiHighlight()}
                {this.renderCustomizationTease()}
                {this.renderFinalCta()}
                {this.renderFooter()}
            </div>
        );
    }

    // ── Donate dialog (authenticated users) ──

    handleOpenDonateDialog = () => {
        this.setState({
            isDonateDialogOpen: !this.state.isDonateDialogOpen,
        })
    }

    blockDonationDialog = () => {
        UserLocalStorage.set('block_donation_dialog', true);
        this.forceUpdate();
    }

    redirectToSettings = () => {
        this.props.navigate(UrlBuilder.user.settingsPage() + '?goToDonation=1');
    }

    renderDonateDialog = (user) => {
        if (UserLocalStorage.get('block_donation_dialog') || user.isSupporter || !Utils.isAndroidApp()) {
            return null;
        }

        const {classes} = this.props;

        const userCreationDate = user.dateCreated ? new Date(user.dateCreated) : null;

        const oneMonthAgo = new Date();
        oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);

        if (userCreationDate && userCreationDate > oneMonthAgo) {
            return null;
        }

        return <Alert variant="filled" severity="info" icon={false} className={classes.dialogRoot} onClick={this.handleOpenDonateDialog} action={this.state.isDonateDialogOpen ? <ExpandLessIcon/> : <ExpandMoreIcon/>}>
            <AlertTitle>Love Using My Work in Progress? Help Keep Us Strong!</AlertTitle>

            <Collapse in={this.state.isDonateDialogOpen}>
                <Typography>
                    I sincerely hope you enjoy using My Work in Progress and it adds value to your life. It's my mission to help you keep track of your fitness journey with no strings attached.

                    At the same time, keeping the app free and constantly improving it comes with certain costs - from server upkeep to new feature development. If you love using this app and would like to contribute towards its growth and sustainability, please consider making a donation.

                    Every little bit helps us to continue delivering a premium, ad-free experience, and to keep shaping My Work in Progress into the best workout tracker it can be.

                    Let's keep growing stronger together!
                </Typography>
                <Button variant="contained" className={classes.button} color='secondary' onClick={this.redirectToSettings}>
                    DONATE
                </Button>
                <Button variant="contained" className={classes.button} color='primary' onClick={this.blockDonationDialog}>
                    Close
                </Button>
            </Collapse>
        </Alert>
    }

    // ── Main render ──

    render() {
        return (
            <UserContext.Consumer>
                {({user}) => user ?
                    <React.Fragment>
                        <Box paddingTop={2} />

                        {this.renderDonateDialog(user)}

                        <WorkoutsModule/>

                        <HomeFabButton/>
                    </React.Fragment>
                    :
                    this.renderNoUserPage()
                }
            </UserContext.Consumer>
        );
    }
}

Home.contextType = PageDataContext;

export default withStyles(useStyles)(withRouter(Home));
